import React, { useCallback } from 'react';
import { IconButton } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { RemoveCircleSharp } from '@material-ui/icons';
import { PropTypes } from 'prop-types';

const RemoveContactButton = ({
  record,
  column: {
    contactHandlers: { onRemoveContact }
  }
}) => {
  const { formatMessage } = useIntl();

  const handleChange = useCallback(() => {
    onRemoveContact(record);
  }, [onRemoveContact, record]);

  return (
    <>
      <IconButton
        data-qe-id="RemoveContact"
        aria-label={formatMessage({
          id:
            'projectBasicInfoCard.contactInfo.actions.deleteConfirmationDialog.removeContact'
        })}
        onClick={handleChange}
      >
        <RemoveCircleSharp />
      </IconButton>
    </>
  );
};

RemoveContactButton.propTypes = {
  record: PropTypes.object,
  column: PropTypes.object
};

export default RemoveContactButton;
